import { graphql } from "gatsby"
import React from "react"

import Hero from "@organisms/Hero/Hero"

const FrontPageHero = ({ blockDataFrontPageHero }) => {
  const { heading, image, imagemobile, variant, link } =
    blockDataFrontPageHero || {}

  return (
    <Hero
      title={heading}
      image={image}
      imageMobile={imagemobile}
      imagePreload={true}
      variant={variant}
      cta={link}
      overlay={{
        color: "#000",
        opacity: 0.0,
      }}
    />
  )
}

export const query = graphql`
  fragment FrontPageHero on WpBlockAcfFrontPageHero {
    __typename
    blockDataFrontPageHero {
      variant
      heading
      image {
        mediaDetails {
          width
          height
        }
        cloudinaryDetails {
          public_id
          original_filename
          format
        }
        sourceUrl
        altText
        altTextOriginal
      }
      imagemobile {
        mediaDetails {
          width
          height
        }
        cloudinaryDetails {
          public_id
          original_filename
          format
        }
        sourceUrl
        altText
        altTextOriginal
      }
      link {
        target
        title
        url
      }
    }
  }
`

export default FrontPageHero
